import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories, MAIN_SITE_URL } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-sm">
                U
              </span>
              <span className="font-heading font-bold text-background-50 text-lg">{t("brand")}</span>
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">{t("footer_about")}</p>
            <p className="mt-3 text-xs text-background-400">{t("footer_disclaimer")}</p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">{t("footer_links")}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors">
                  {t("nav_home")}
                </Link>
              </li>
              <li>
                <Link to="/shopping-guide" className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors">
                  {t("nav_shop_guide")}
                </Link>
              </li>
              <li>
                <Link to="/#categories" className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors">
                  {t("nav_categories")}
                </Link>
              </li>
              <li>
                <Link to="/#articles" className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors">
                  {t("nav_articles")}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors"
                >
                  {t("nav_visit")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">{t("footer_categories")}</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.slug}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors"
                  >
                    {t(`cats.${c.slug}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">{t("footer_categories")}</h4>
            <ul className="space-y-2.5">
              {categories.slice(6).map((c) => (
                <li key={c.slug}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors"
                  >
                    {t(`cats.${c.slug}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="max-w-[1280px] mx-auto mt-10 pt-6 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">© {new Date().getFullYear()} {t("brand")}. {t("footer_rights")}</p>
          <p className="text-xs text-background-400">{t("footer_disclaimer")}</p>
        </div>
      </div>
    </footer>
  );
}